import { getSpaceUpdatesResponseSchema } from "@wakeloop/schemas";
import type {
  GetSpaceUpdatesResponse,
  WakeLoopRequestContext,
} from "@wakeloop/schemas/types";
import { buildWakeLoopRequestContextHeadersWithAuth } from "../config/request-headers";
import { toSpaceUpdatesUrl } from "../protocol/urls";
import { parseJsonResponse } from "./api-json";
import { fetchSpaceRequestWithTimeout } from "./fetch-with-timeout";
import { readGatewayTextResponse } from "./gateway-response";

export async function fetchSpaceUpdates(input: {
  requestContext: WakeLoopRequestContext;
  baseUrl: string;
  space: string;
  afterSignalId: string;
  limit: number;
  password?: string;
}): Promise<GetSpaceUpdatesResponse> {
  const endpoint = new URL(toSpaceUpdatesUrl(input.baseUrl, input.space));
  endpoint.searchParams.set("afterSignalId", input.afterSignalId);
  endpoint.searchParams.set("limit", String(input.limit));

  const response = await fetchSpaceRequestWithTimeout({
    url: endpoint.toString(),
    operation: "space.updates.read",
    init: {
      headers: await buildWakeLoopRequestContextHeadersWithAuth({
        requestUrl: endpoint.toString(),
        requestContext: input.requestContext,
        spacePassword: input.password,
      }),
    },
  });
  const raw = await readGatewayTextResponse({ response });

  const parsed = getSpaceUpdatesResponseSchema.safeParse(
    parseJsonResponse(raw)
  );
  if (!parsed.success) {
    throw new Error("invalid space updates response");
  }
  return parsed.data;
}
